'use client'

import { Provider } from 'react-redux'
import { makeStore, AppStore } from '@/lib/redux/store'
import { useDeviceResize } from '@/hooks/app/useDeviceResize'

export const storeRef: { current: AppStore | null } = { current: null }

export default function StoreProvider({
  children
}: {
  children: React.ReactNode
}) {
  if (!storeRef.current) {
    // Create the store instance the first time this renders
    storeRef.current = makeStore()
  }

  return <Provider store={storeRef.current}>{children}</Provider>
}